// extracted by mini-css-extract-plugin
export default {"registrationThrough":"registration-through-app_registrationThrough__PejVV","appImage":"registration-through-app_appImage__iDUpD"};